// Global status constants
const GLOBAL_STATUS_DISABLED = 'd';
const GLOBAL_STATUS_ENABLED = 'e';

// Feature key constants
const KEY_CONTACTS = 'con';
const KEY_PIPELINES = 'pip';
const KEY_MONEY_SCORE = 'mon';
const KEY_WEBSITES = 'ws';
const KEY_REFERRAL_MARKETING = 'rm';
const KEY_AUGMENTATION = 'aug';
const KEY_TEXT_MESSAGING = 'txt';
const KEY_BLOGS = 'blog';
const KEY_VIDEOS = 'v';
const KEY_AUTOMATIC_PLANS = 'auto';
const KEY_TEAMS = 't';
const KEY_SOCIAL_BRANDING = 'sb';
const KEY_ADDITIONAL_MARKETING = 'am';
const KEY_SUPPORT = 'sup';
const KEY_LEAD_FILES = 'f';
const KEY_LISA = 'lisa';
const KEY_ISA = 'isa';
const KEY_COMMUNITY = 'co';
const KEY_FULL_SERVICE_EMAIL = 'fse';
const KEY_SELF_SERVICE_EMAIL = 'sse';
const KEY_WEBHOOKS = 'wh';
const KEY_COMMISSION_SHARE_PROGRAM = 'csp';
const KEY_SAVED_SEARCHES = 'ss';
const KEY_MARKET_UPDATE = 'mu';
const KEY_ADDITIONAL_MARKETING_LEAD_GEN = 'aml';
const KEY_ADDITIONAL_MARKETING_RETARGETING = 'amr';
const KEY_ADDITIONAL_MARKETING_SMART_LISTS = 'ams';
const KEY_MY_FILES = 'mf';
const KEY_BILLING = 'bl';
const KEY_CALENDAR = 'cal';
const KEY_HOME_VALUES = 'hv';
const KEY_SEARCH_QUIZ = 'sq';
const KEY_EVENTS = 'ev';
const KEY_SERVICE_AREAS = 'sa';
const KEY_VOICE_RECORDINGS = 'vr';
const KEY_CONNECTED_ACCOUNTS = 'ca';
const KEY_UNIVERSITY = 'uv';
const KEY_EMAIL_BLASTS = 'eb';
const KEY_TASKS = 'ta';
const KEY_USAGE = 'usage';
const KEY_IMPORT_LEADS = 'il';
const KEY_MANUAL_LEADS = 'ml';
const KEY_HJ_PLUS = 'hjp';
const KEY_HJ_PLUS_UPGRADE_BANNER = 'hjub';
const KEY_PUBLIC_PROFILE = 'pprof';
const KEY_MAILBOX = 'mb';
const KEY_ACCESS_ALL_LEADS = 'aal';
const KEY_CANCEL_ACCOUNT = 'cacc';
const KEY_SHARED_PIPELINES = 'sp';
const KEY_CALL_AGENT_LEADS = 'call';
const KEY_UPGRADE = 'u';
const KEY_TESTIMONIALS = 'tes';
const KEY_PROSPECT_LIST = 'pl';
const KEY_AI_BLOGS = 'aib';
const KEY_PREMIUM_WEBSITE_THEMES = 'pwt';
const KEY_AI_AGENT = 'ai';
const KEY_VOICEMAIL = 'vm';

export const FeatureFlags = {
    GLOBAL_STATUS_DISABLED,
    GLOBAL_STATUS_ENABLED,
    KEY_CONTACTS,
    KEY_PIPELINES,
    KEY_MONEY_SCORE,
    KEY_WEBSITES,
    KEY_REFERRAL_MARKETING,
    KEY_AUGMENTATION,
    KEY_TEXT_MESSAGING,
    KEY_BLOGS,
    KEY_VIDEOS,
    KEY_AUTOMATIC_PLANS,
    KEY_TEAMS,
    KEY_SOCIAL_BRANDING,
    KEY_ADDITIONAL_MARKETING,
    KEY_SUPPORT,
    KEY_LEAD_FILES,
    KEY_LISA,
    KEY_ISA,
    KEY_COMMUNITY,
    KEY_FULL_SERVICE_EMAIL,
    KEY_SELF_SERVICE_EMAIL,
    KEY_WEBHOOKS,
    KEY_COMMISSION_SHARE_PROGRAM,
    KEY_SAVED_SEARCHES,
    KEY_MARKET_UPDATE,
    KEY_ADDITIONAL_MARKETING_LEAD_GEN,
    KEY_ADDITIONAL_MARKETING_RETARGETING,
    KEY_ADDITIONAL_MARKETING_SMART_LISTS,
    KEY_MY_FILES,
    KEY_BILLING,
    KEY_CALENDAR,
    KEY_HOME_VALUES,
    KEY_SEARCH_QUIZ,
    KEY_EVENTS,
    KEY_SERVICE_AREAS,
    KEY_VOICE_RECORDINGS,
    KEY_CONNECTED_ACCOUNTS,
    KEY_UNIVERSITY,
    KEY_EMAIL_BLASTS,
    KEY_TASKS,
    KEY_USAGE,
    KEY_IMPORT_LEADS,
    KEY_MANUAL_LEADS,
    KEY_HJ_PLUS,
    KEY_HJ_PLUS_UPGRADE_BANNER,
    KEY_PUBLIC_PROFILE,
    KEY_MAILBOX,
    KEY_ACCESS_ALL_LEADS,
    KEY_CANCEL_ACCOUNT,
    KEY_SHARED_PIPELINES,
    KEY_CALL_AGENT_LEADS,
    KEY_UPGRADE,
    KEY_TESTIMONIALS,
    KEY_PROSPECT_LIST,
    KEY_AI_BLOGS,
    KEY_PREMIUM_WEBSITE_THEMES,
    KEY_AI_AGENT,
    KEY_VOICEMAIL
}